<mat-toolbar color="primary">
  <span id="send-møteinnkalling-dialog-tittel">
    {{ "Send innkalling til {moetenavn} {moetenummer} - {gruppetittel} ({organisasjonsnavn})"|translate: {moetenummer: moete().nummer, moetenavn: moete().tittel, gruppetittel: gruppe().tittel, organisasjonsnavn: gruppe().organisasjonsnavn} }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@switch (modus()) {
  @case ('skjema') {
    <form [formGroup]="skjema" (ngSubmit)="publiser()" data-testid="send-møteinnkalling-skjema">
      @if (laster()) {
        <mat-progress-bar mode="indeterminate"/>
      }
      <mat-dialog-content class="skjema">
        <fieldset>
          <mat-form-field>
            <mat-label>{{ 'Skriv inn beskjed inkludert i innkallingen'|translate }}</mat-label>
            <riktekst-redigering [skjemakontroll]="skjema.controls.beskjed" [gruppeId]="moete().eiendeGruppeId" data-testid="beskjed-felt"/>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'Mottakere' | translate }}</mat-label>
            <mat-icon matPrefix fontSet="ion-ios-people-outline" class="mat-icon--ionic-ikon"/>
            <velg-medlemmer [skjemakontroll]="skjema.controls.valgteMottakere" [medlemmer]="tilgjengeligeMottakere">
              <ng-template let-medlem>
                <medlem-listevisning-kompakt [medlem]="medlem">
                  <span class="invitasjon-status" [class.ikke-sendt]="erInvitasjonIkkeSendt(medlem)">{{ invitasjonsStatus(medlem) }}</span>
                </medlem-listevisning-kompakt>
              </ng-template>
            </velg-medlemmer>
          </mat-form-field>
        </fieldset>

        <fieldset class="valg">
          <div>
            <mat-slide-toggle [formControl]="skjema.controls.inkluderAgenda" data-testid="inkluder-agenda-felt">
              <span>{{ 'Inkludér saksliste (saksnavn) i innkalling'|translate }}</span>
              <div class="undertekst">{{ 'Ikke skru på om saksnavn inneholder sensitiv informasjon'|translate }}</div>
            </mat-slide-toggle>
            @if (inkluderAgendaEndret() ) {
              <mat-checkbox [formControl]="skjema.controls.huskInkluderAgendaValg" data-testid="inkluder-agenda-husk-felt">{{ 'husk dette valget'|translate }}</mat-checkbox>
            }
          </div>
          @if (!moete().erMoetePublisert) {
            <mat-slide-toggle [formControl]="skjema.controls.publiserMoete" data-testid="publiser-møte-felt"
                              matTooltip="{{'Møtet er ikke publisert, medlemmer uten tilgang til ikke-publisert informasjon vil ikke kunne se møte- og saksdetaljer'|translate}}">
              {{ 'Publiser møte'|translate }}
            </mat-slide-toggle>
          }
        </fieldset>
      </mat-dialog-content>

      <mat-dialog-actions align="center">
        <div>
          <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
          <button mat-raised-button color="primary" type="submit" cdkFocusInitial
                  [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()"
                  spinnerTekst="{{'Sender...'|translate}}" data-testid="send">
            {{ 'Send innkalling'|translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </form>
  }
  @case ('kvittering') {
    <mat-dialog-content class="kvittering">
      <p>
        {{ 'E-post med innkalling til møtet har blitt sendt til {antall} medlemmer.'|translate: {antall: skjema.value.valgteMottakere!.length} }}
      </p>
      <tips>
        {{ 'Du finner en oversikt over meldinger sendt til medlemmer i'|translate }}
        <a (click)="gaaTilHendelseslogg()">{{ 'møtets hendelseslogg'|translate }}</a>
      </tips>
      <melding-sendt-ikon/>

    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div>
        <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
          {{ 'Lukk'|translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }
}
